module.exports = __webpack_public_path__ + "static/media/social5.53114a45.svg";